import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('en');
  const selectorRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'zh', name: '中文' },
    { code: 'hi', name: 'हिन्दी' },
    { code: 'fr', name: 'Français' },
    { code: 'ar', name: 'العربية' },
    { code: 'bn', name: 'বাংলা' },
    { code: 'pt', name: 'Português' },
    { code: 'ru', name: 'Русский' },
    { code: 'de', name: 'Deutsch' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleLangChange = (lng) => {
      setCurrentLang((lng || i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]);
    };
    handleLangChange(i18n.language);
    i18n.on('languageChanged', handleLangChange);
    return () => {
      i18n.off('languageChanged', handleLangChange);
    };
  }, [i18n]);

  const getCurrentLanguage = () => {
    const code = (i18n.resolvedLanguage || i18n.language || currentLang || 'en').split('-')[0];
    return languages.find(lang => lang.code === code)?.name || 'English';
  };

  const handleLanguageChange = (code) => {
    try {
      window.localStorage.setItem('i18nextLng', code);
      window.localStorage.setItem('fm_lang', code);
    } catch (e) {
      // ignore storage errors
    }
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-selector" ref={selectorRef}>
      <div 
        className={`language-select-button ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{getCurrentLanguage()}</span>
        <span className="arrow">▼</span>
      </div>
      
      {isOpen && (
        <>
          <div className="language-overlay" onClick={() => setIsOpen(false)} />
          <div className="language-dropdown">
            {languages.map(lang => (
              <div
                key={lang.code}
                className={`language-option ${((i18n.resolvedLanguage || i18n.language || currentLang || 'en').split('-')[0] === lang.code) ? 'selected' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {lang.name}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector; 